import { InternalLink } from 'src/components/atoms/Link'
import { SanityImage } from 'src/components/atoms/SanityImage'
import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'

import { viewBlogPostPath } from 'src/config/paths'
import { PostsQueryPost } from 'src/server/router/sanity/groq/post/types'
import { formatDate } from 'src/utils/date'

export interface BlogPostCardRebrandProps {
  post: PostsQueryPost
}

export const BlogPostCardRebrand = ({ post }: BlogPostCardRebrandProps) => {
  const formattedDate = formatDate({
    date: post.publishedAt,
    isUtc: true,
    format: 'DD MMM YYYY'
  })

  return (
    <InternalLink
      color='none'
      href={viewBlogPostPath({ routeParams: { slug: post.slug.current } })}
      className='flex flex-col gap-4'
    >
      <div className='relative h-[334px] lg:h-[430px] w-full overflow-hidden'>
        <SanityImage
          source={post.mainImage}
          sourceWidth={780}
          sourceHeight={860}
          fill
          alt={post.title}
          className='object-cover object-center'
        />
      </div>
      <TypographyRebrand variant='h5' color='forestDeep'>
        {post.title}
      </TypographyRebrand>
      <TypographyRebrand variant='eyebrow' color='forestDeep'>
        {formattedDate}
      </TypographyRebrand>
    </InternalLink>
  )
}
